export default function createWebhookStoreRequest(formData) {
  return {
    url: formData.url,
    webhook_types: formData.webhookTypes,
    is_active: formData.isActive,
  };
}
